/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import moment from 'moment';
import { CssTextField, formatTime } from 'components/helper/helperInut';
import { DatePicker } from '@mui/x-date-pickers';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';

interface Props {
  id?: string;
  mdCol?: string;
  label?: string;
  name: string;
  values: string | null | undefined;
  onChange: (e: any) => void;
  isValid?: boolean;
  feedback?: any;
  placeholder?: any;
  disabled?: boolean;
  className?: string;
  maxDate?: any;
  format?: string;
  hidden?: boolean;
  logo?: string;
  isMissing?: any;
  isCuScuLogo?: boolean;
  isTestCsuLogo?: boolean;
  readOnly?: boolean;
  setLabelHight?: boolean;
}

const DatePickerInput = (props: Props) => {
  const [notValidLabel, setNotValidLabel] = React.useState<string | undefined>();
  const handleChange = (e: any) => {
    try {
      if (moment(e).isValid()) {
        props.onChange(formatTime(e));
        setNotValidLabel(undefined);
      } else {
        setNotValidLabel('Invalid date');
        props.onChange(null);
      }
    }
    catch(ex){
      console.log('Error:', ex);
    }
  };

  //#region Fix className content justify-content-xxx
  // let className = `${(props.isCuScuLogo || props.isTestCsuLogo) ? '' : 'd-flex'
  //   } flex-column justify-content-end ps-1 pe-2 py-2 `;
  // if (props.className?.includes('justify-content-')) {
  //   className = className.replace('justify-content-end ', '');
  // }
  // className = `${className} ${props.className ?? ''}`.trim();
  //#endregion

  return !props.hidden ? (
    <FormControl
      id={props.id}
      disabled={props.disabled}
      error={!!props.isMissing}
      sx={{ width: '100%' }}
      className={props.className}
    >
      <div
        style={
          props.setLabelHight
            ? {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-end',
                minHeight: '40px',
              }
            : { marginBottom: '2px' }
        }
      >
        <FormLabel
          className={`select-label label-14px`}
          sx={{
            display: 'flex',
            alignItems: 'center',
            fontSize: '14px',
            margin: props.setLabelHight ? 0 : undefined,
            marginBottom: '1px !important',
            backgroundColor: props.isMissing ? '#FFEBEB' : '',
          }}
        >
          <span>{props.label}</span>
          {(props?.logo && props.setLabelHight) && (
            <FormLabel className={`csu-logo-select-input-float-right ${props?.logo ?? ''}`.trim()} />
          )}
        </FormLabel>
        {(props?.logo && !props.setLabelHight && !props.isTestCsuLogo && !props.isCuScuLogo) ? <span className={`cm-logo-select-input-float-right ${props?.logo ?? null}`}></span> : null}
        {(props?.logo && props.isTestCsuLogo) ? <span className={`csu-logo-sat-text-float-right ${props?.logo ?? null}`}></span> : null}
        {(props?.logo && props.isCuScuLogo) ? <span className={`csu-logo-cu-csu-citizen-right ${props?.logo ?? null}`}></span> : null}
      </div>
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '0.5rem',
          fontSize: '16px',
          userSelect: 'none'
        }}
      >
        <DatePicker
          readOnly={props.readOnly}
          disabled={props.disabled}
          label="Date desktop"
          inputFormat={props.format ?? 'MM/DD/yyyy'}
          value={props.values ? props.values : ' '}
          onChange={handleChange}
          maxDate={props.maxDate}
          renderInput={(params) => {
            let newParams: any = {
              ...params,
              placeholder: props.placeholder,
              label: undefined,
            };
            return (
              <>
                <CssTextField id={`${props.id}`} name={`${props.id}`} {...newParams} error={false} />
              </>
            );
          }}
        />
      </div>
      {props.feedback && (
        <div className="text-field-light sized70 w-100 d-flex justify-content-between mh-1rem">
          {props.feedback}
        </div>
      )}
      {notValidLabel && <div className="sized70 text-danger text-end">{notValidLabel}</div>}
    </FormControl>
  ) : null;
};
export default DatePickerInput;
